import { MAIN_URL, REQUEST_URL } from "../../constant/ApplicationVariables";
import { axiosInstance } from "../useAxios/useAxios";

/**
 * Get List of Teams
 */
export const getTeamsList_API = async () => {
  try {
    const response = await axiosInstance({
      url: MAIN_URL.url + REQUEST_URL.teamList,
      method: "GET",
      contentType: "application/json",
    });
    return response;
  } catch (error) {
    return error;
  }
};

/**
 * Get Team Details
 * @param {string} query - e.g., name=QA Team
 */
export const getTeamDetails_API = async (query) => {
  try {
    const response = await axiosInstance({
      url: MAIN_URL.url + REQUEST_URL.teamDetails + `${query ? `?${query}` : ""}`,
      method: "GET",
      contentType: "application/json",
    });
    return response;
  } catch (error) {
    return error;
  }
};

/**
 * Create Team
 */
export const createTeam_API = async (body) => {
  try {
    const response = await axiosInstance({
      url: MAIN_URL.url + REQUEST_URL.createTeam,
      method: "POST",
      data: body,
      contentType: "application/json",
    });
    return response;
  } catch (error) {
    return error;
  }
};

/**
 * Update Team
 */
export const updateTeam_API = async (body) => {
  try {
    const response = await axiosInstance({
      url: MAIN_URL.url + REQUEST_URL.updateTeam,
      method: "PUT",
      data: body,
      contentType: "application/json",
    });
    return response;
  } catch (error) {
    return error;
  }
};


export const deleteTeam_API = async (query) => {
  try {
    const response = await axiosInstance({
      url: MAIN_URL.url + REQUEST_URL.deleteTeam + (query ? `?${query}` : ""),
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  } catch (error) {
    return error;
  }
};
